import AuthService from '../services/auth.service.js';
import { ROLE_ADMIN, ROLE_MANAGER, OSD_PROCESSING_ROLES } from '../constants/roles';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  getters: {
    token: (state) => {
      return state.user?.token;
    },
    expiration: (state) => {
      return state.user?.expiration;
    },
    loggedIn: (state) => {
      return state.status?.loggedIn;
    },
    user: (state) => {
      return state.user?.username;
    },
    roles: (state) => {
      return state.user?.roles ?? [];
    },
    isAdmin: (state) => {
      return (state.user?.roles ?? []).includes(ROLE_ADMIN);
    },
    isManager: (state) => {
      return (state.user?.roles ?? []).includes(ROLE_MANAGER);
    },
    // BBatts: OS&D processing (queue/destroyed/counts/destroy) is Manager/Admin
    // only; Dock reports exceptions but doesn't process them.
    canProcessOsd: (state) => {
      return (state.user?.roles ?? []).some((role) => OSD_PROCESSING_ROLES.includes(role));
    },
  },
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        (resp) => {
          commit('loginSuccess', resp.result);
          return Promise.resolve(resp.result);
        },
        (error) => {
          commit('loginFailure');
          console.log('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      //AuthService.logout();
      commit('logout');
    },
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      localStorage.removeItem('user');
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
  },
};
